import { render } from "react-dom"
import { createElement, Fragment } from "react"
import { GraphiQL } from "graphiql"
// I am not sure how else to get webpack to not run it's custom css pipeline
import graphiqlStyles from "!!file-loader!graphiql/graphiql.min.css"
import customStyles from "!!file-loader!./style.css"

function getDefaultHeaders(sessionToken) {
  return sessionToken === "SKIP_AUTH"
    ? {}
    : { Authorization: `Bearer ${sessionToken}` }
}

async function fetchDefaultQuery(dbId, sessionToken) {
  if (!sessionToken) {
    return callback("query DefaultQuery { }")
  }

  const errMsg = "Following error occurred while loading the default query: \n"

  try {
    const response = await fetch(`/dbs/${dbId}/playground/default-query`, {
      headers: getDefaultHeaders(sessionToken),
    })

    if (!response.ok) {
      return `${errMsg} HTTP error ${response.status}`
    } else {
      return response.text()
    }
  } catch (error) {
    return `${errMsg} - ${String(error)}`
  }
}

function mkGraphQLFetcher(sessionToken, dbId) {
  return (graphQLParams) => {
    if (!sessionToken) {
      return Promise.resolve({
        errors: [{ message: "No session token provided" }],
      })
    }

    return fetch(`/dbs/${dbId}/graphql`, {
      method: "POST",
      headers: Object.assign(
        {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        getDefaultHeaders(sessionToken),
      ),
      body: JSON.stringify(graphQLParams),
      credentials: "omit",
    }).then((response) => response.json().catch(() => response.text()))
  }
}

export class AirsequelPlayground extends HTMLElement {
  connectedCallback() {
    const hash = window.location.hash.slice(1)
    const hashParams = new URLSearchParams(hash)
    const queryParams = new URLSearchParams(window.location.search)

    const dbId = this.getAttribute("db-id") || queryParams.get("db-id")
    const sessionToken =
      this.getAttribute("session-token") || hashParams.get("session-token")

    const reactRoot = document.createElement("div")
    reactRoot.id = "graphiql-root"
    this.appendChild(reactRoot)

    fetchDefaultQuery(dbId, sessionToken).then((defaultQuery) => {
      render(
        createElement(
          Fragment,
          null,
          createElement("link", {
            rel: "stylesheet",
            href: graphiqlStyles,
          }),
          createElement("link", {
            rel: "stylesheet",
            href: customStyles,
          }),
          createElement(
            GraphiQL,
            {
              fetcher: mkGraphQLFetcher(sessionToken, dbId),
              visiblePlugin: "Documentation Explorer",
              defaultQuery,
            },
            createElement(GraphiQL.Logo, null, ""),
          ),
        ),
        reactRoot,
      )
    })
  }
}
